// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_8cw","cls2":"AuthorHeader-cls2_MXF AuthorHeader-cls1_8cw"};